const SERVER_PATH = "";
module.exports = {
	axiosRoutes: {
		subject: {
			new: `${SERVER_PATH}/subject`,
			getAll: `${SERVER_PATH}/subject`,
			getOne: `${SERVER_PATH}/subject`,
			delete: `${SERVER_PATH}/subject`,
			edit: `${SERVER_PATH}/subject`,
		},
		parent: {
			new: `${SERVER_PATH}/parent`,
			getAll: `${SERVER_PATH}/parent`,
			getOne: `${SERVER_PATH}/parent`,
			delete: `${SERVER_PATH}/parent`,
			edit: `${SERVER_PATH}/parent`,
			setPassword: `${SERVER_PATH}/parent/setPassword/`,
			reset: `${SERVER_PATH}/parent/resetPassword`,
		},
		address: {
			new: `${SERVER_PATH}/address`,
			getAll: `${SERVER_PATH}/address`,
			getOne: `${SERVER_PATH}/address`,
			update: `${SERVER_PATH}/address/`, //+`{id}` PUT,
			delete: `${SERVER_PATH}/address/`, //+`{id}` DELETE,
		},
		session: {
			get: `${SERVER_PATH}/remembrance`,
			delete: `${SERVER_PATH}/remembrance`,
		},
		payment: {
			new: `${SERVER_PATH}/payment`,
			resume: `${SERVER_PATH}/payment/resume`,
			getAll: `${SERVER_PATH}/payment`,
			// getOne: `${SERVER_PATH}/payment`,
		},
		subscription: {
      freeAccess: `${SERVER_PATH}/subscription/free-access`,
			status: `${SERVER_PATH}/subscription/status`,
			cancel: `${SERVER_PATH}/subscription/cancel`,
			updateCard: `${SERVER_PATH}/subscription/update-card`,
		},
		adminSubscriptionPlan: {
			getAll: `${SERVER_PATH}/admin/subscription-plans`,
			create: `${SERVER_PATH}/admin/subscription-plans`,
			promote: `${SERVER_PATH}/admin/subscription-plans/`, // append `${id}/promote`
		},
		productPackage: {
			new: `${SERVER_PATH}/productpackage`, // POST need auth
			getAll: `${SERVER_PATH}/productpackage`, // GET
			getOne: `${SERVER_PATH}/productpackage/`, // GET with id
			update: `${SERVER_PATH}/productpackage/`, // PUT with id need auth
			delete: `${SERVER_PATH}/productpackage/`, // DELETE with id need auth
		},
		profile: {
			edit: `${SERVER_PATH}/profile`,
			my: `${SERVER_PATH}/profile/my`,
			getOne: `${SERVER_PATH}/profile`,
			getAll: `${SERVER_PATH}/profile`,
		},
		calendar: {
			new: `${SERVER_PATH}/calendar`,
			getAll: `${SERVER_PATH}/calendar`,
			getOne: `${SERVER_PATH}/calendar`,
			delete: `${SERVER_PATH}/calendar`,
			edit: `${SERVER_PATH}/calendar`,
		},
		discount: {
			new: `${SERVER_PATH}/discountCoupon`,
			getAll: `${SERVER_PATH}/discountCoupon`,
			edit: `${SERVER_PATH}/discountCoupon/`, // put , append id
		},
		auth: {
			login: `${SERVER_PATH}/auth/login`,
			loginIntent: `${SERVER_PATH}/auth/login/intent`,
			loginFinalize: `${SERVER_PATH}/auth/login/finalize`,
			register: `${SERVER_PATH}/auth/register`,
/* eslint-disable */
			phoneRegisterRequest: `${SERVER_PATH}/auth/phone/register/request-otp`,
			phoneRegisterVerify: `${SERVER_PATH}/auth/phone/register/verify-otp`,
			phoneChangeRequest: `${SERVER_PATH}/auth/phone/change/request-otp`,
			phoneChangeVerify: `${SERVER_PATH}/auth/phone/change/verify-otp`,
			phoneSetupRequest: `${SERVER_PATH}/auth/phone/setup/request-otp`,
			phoneSetupVerify: `${SERVER_PATH}/auth/phone/setup/verify-otp`,
			passwordChangeRequest: `${SERVER_PATH}/auth/password/request-otp`,
			passwordChangeVerify: `${SERVER_PATH}/auth/password/verify-otp`,
			factorRecover: `${SERVER_PATH}/auth/factor/recover`,
			emailChangeRequest: `${SERVER_PATH}/auth/email/request-otp`,
			emailChangeVerify: `${SERVER_PATH}/auth/email/verify-otp`,
			emailConfirmRequest: `${SERVER_PATH}/auth/email/confirm/request-otp`,
			emailConfirmActive: `${SERVER_PATH}/auth/email/confirm/active`,
      /* eslint-enable */
			forgot: `${SERVER_PATH}/auth/forgot`,
			reset: `${SERVER_PATH}/auth/reset`,
			dashboardStats: `${SERVER_PATH}/auth/dashboardStats`,
		},
		exercise: {
			new: `${SERVER_PATH}/exercises/`, // /:subjectId || POST method
			print: `${SERVER_PATH}/exercises/`, // /:id || GET method
			lean: `${SERVER_PATH}/exercises/lean/`, // /:id || GET method || returns params only
			result: `${SERVER_PATH}/exercise/addResult/`, // /:id || POST method
			resultList: `${SERVER_PATH}/exercise/addResultList`, //  POST method
			list: `${SERVER_PATH}/exercise/list/`, // /:subjectId || GET method
			stats: `${SERVER_PATH}/exercise/stats/`, // /:subjectId || GET method
			compare: `${SERVER_PATH}/exercise/compare/`, // /:subjectId || GET method
			check: `${SERVER_PATH}/exercise/checkExists/`, // /:uID || POST method
			getsubject: `${SERVER_PATH}/exercise/forsubject/`, // /:uID || GET method
			liveReqs: `${SERVER_PATH}/exercise/liveReqs/`, // /:uID || GET method
		},
		blog: {
			new: `${SERVER_PATH}/blog`, // POST
			getAll: `${SERVER_PATH}/blog`, // GET
			getOne: `${SERVER_PATH}/blog/`, // GET with id OR slug
			delete: `${SERVER_PATH}/blog/`, // DELETE with id , need permission
			edit: `${SERVER_PATH}/blog/`, // PATCH with id , need permission
		},
		blogComment: {
			new: `${SERVER_PATH}/blogComment/`, // POST with blogID
			getAll: `${SERVER_PATH}/blogComment/`, // GET with blogID
			getOne: `${SERVER_PATH}/blogComment/`, // GET with blogID and commentID
			delete: `${SERVER_PATH}/blogComment/`, // DELETE with blogID and commentID , need permission
			edit: `${SERVER_PATH}/blogComment/`, // PATCH with blogID and commentID , need permission
		},
		permission: {
			new: `${SERVER_PATH}/permission`,
			getAll: `${SERVER_PATH}/permission`,
			getOne: `${SERVER_PATH}/permission`, // /:id || GET method
			delete: `${SERVER_PATH}/permission`, // /:id || DELETE method
			edit: `${SERVER_PATH}/permission`, // /:id || PATCH method
		},
		user: {
			new: `${SERVER_PATH}/user`,
			getAll: `${SERVER_PATH}/user`,
			getOne: `${SERVER_PATH}/user`, // /:id || GET method
			my: `${SERVER_PATH}/user/my`,
			referrals: `${SERVER_PATH}/user/referrals`,
			// delete: `${SERVER_PATH}/user`,
			edit: `${SERVER_PATH}/user`, // /:id || PATCH method
			grantTrial: `${SERVER_PATH}/user`, // /:id/trial || PATCH method, sysAdmin only
			approvalBlock: `${SERVER_PATH}/user`, // /:id/approval-block || PATCH method, sysAdmin only
			publicVisibility: `${SERVER_PATH}/user`, // /:id/public-visibility || PATCH method, sysAdmin only
			subscriptionAdmin: `${SERVER_PATH}/user`, // /:id/subscription || DELETE method, sysAdmin only
		},
		approval: {
			new: `${SERVER_PATH}/approval`,
			getAll: `${SERVER_PATH}/approval`,
			getOne: `${SERVER_PATH}/approval`, // /:id || GET method
			// delete: `${SERVER_PATH}/user`,
			edit: `${SERVER_PATH}/approval`,
		},
		account: {
			get: `${SERVER_PATH}/account`,
		},
		admin: {
			// Lives on the main /user router (D1's requireSysAdmin route), not
			// the /admin/* panel below -- grouped here because it's sysAdmin-only,
			// same as this group's other entries.
			purgeKnownAccounts: `${SERVER_PATH}/user/purge-known-accounts`, // POST method, sysAdmin only, hardcoded 4-account purge
			auth: {
				login: `${SERVER_PATH}/admin/auth/login`,
				forgot: `${SERVER_PATH}/admin/auth/forgot`,
				reset: `${SERVER_PATH}/admin/auth/reset`,
			},
			admin: {
				new: `${SERVER_PATH}/admin/admin`,
				getAll: `${SERVER_PATH}/admin/admin`,
				getOne: `${SERVER_PATH}/admin/admin`,
				delete: `${SERVER_PATH}/admin/admin`,
				edit: `${SERVER_PATH}/admin/admin`,
			},
			user: {
				new: `${SERVER_PATH}/admin/user`,
				getAll: `${SERVER_PATH}/admin/user`,
				getOne: `${SERVER_PATH}/admin/user`,
				delete: `${SERVER_PATH}/admin/user`,
				edit: `${SERVER_PATH}/admin/user`,
			},
		},
		qr: {},
		test: {},
		online:{
			get: `${SERVER_PATH}/online`,
			subject:``,
			host:``,
		}
	},
};
